var map = {
	"./vodacom/img.png": 856,
	"./vodacom/vodacom-background-0-desktop.png": 173,
	"./vodacom/vodacom-background-0-mobile.png": 547,
	"./vodacom/vodacom-background-100529-desktop.jpg": 269,
	"./vodacom/vodacom-background-100529-mobile.jpg": 899,
	"./vodacom/vodacom-bg-desktop.jpg": 565,
	"./vodacom/vodacom-bg-mobile.png": 104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 875;